import { PropsWithChildren } from 'react';
import { Advisories } from '../components/advisories/advisories';
import { GlobalAdvisoriesApi } from '../hooks/use-advisories';
import { Outlet } from 'react-router';
import { Header } from '../components/header/header';
import { Alerts } from '../components/header/alerts';
import { Footer } from '../components/footer/footer';

export interface BasePageProps {
    advisoriesApi: GlobalAdvisoriesApi;
}

export interface BaseLayoutProps {
    advidoriesContainerRef: React.RefObject<HTMLDivElement>;
    advisoriesApi: GlobalAdvisoriesApi;
}

export function BaseLayout(props: PropsWithChildren<BaseLayoutProps>) {
    return (
        <>
            <Alerts />
            <Advisories containerRef={props.advidoriesContainerRef} advisories={props.advisoriesApi.advisories} onClose={props.advisoriesApi.remove} />
            <div className="ccl-pageWrap">
                {/* here goes the header */}
                <Header />
                <main>
                    <Outlet />
                    {props.children}
                </main>
                {/* here goes the footer */}
                <Footer />
            </div>
        </>
    );
}